export * from './team-performance';
export * from './chat-dashboard';
export * from './email-dashboard';
export * from './omnichannel-dashboard';
export var DashboardBreakdownType;
(function (DashboardBreakdownType) {
    DashboardBreakdownType[DashboardBreakdownType["GROUP"] = 10] = "GROUP";
    DashboardBreakdownType[DashboardBreakdownType["LANGUAGE"] = 20] = "LANGUAGE";
})(DashboardBreakdownType || (DashboardBreakdownType = {}));
//# sourceMappingURL=index.js.map